import { NativeLayerOutgoingEvent } from "./interfaces"

declare global {
    interface Window {
        ReactNativeWebView?: {
            postMessage: (message: string) => void
        }
    }
}

export const sendNativeLayerEvent = (event: NativeLayerOutgoingEvent) => {
    try {
        if (typeof window !== "undefined" && window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify(event))
        }
    } catch (e) {
        console.error("Failed to send native layer event:", e)
    }
}
